import { useState, useEffect } from 'react';
import { useElementSize } from '@utils/react';
import { useMatchTaskBreakpoint, taskBreakpoints } from '../../../hook.task-breakpoints.js';
import { size } from './_drawer.style.js';

const ROW_HEIGHT = 125;
function useStickyOffsetHandlers(ref, audience) {
  const isMobile = useMatchTaskBreakpoint(taskBreakpoints.mobile);
  const size$1 = useElementSize(ref, {
    applyTo: ref,
    axis: "vertical",
    updateState: true,
    varName: size.propName
  });
  const rowHeight = audience === "default" ? ROW_HEIGHT : ROW_HEIGHT / 1.5;
  const [canChangeOffset, setCanChangeOffset] = useState(true);
  const [stickyOffset, setOffset] = useState(ROW_HEIGHT);
  const updateOffset = nextPosition => {
    const MIN_VALUE = Math.min(size$1.height ?? Infinity, isMobile ? rowHeight : rowHeight * 2);
    const MAX_VALUE = Math.min(size$1.height ?? Infinity, window.innerHeight * 0.9);
    setOffset(Math.max(MIN_VALUE, Math.min(MAX_VALUE, nextPosition)));
  };
  useEffect(() => {
    const MIN_VALUE = Math.min(size$1.height ?? Infinity, isMobile ? rowHeight : rowHeight * 2);
    const MAX_VALUE = Math.min(size$1.height ?? Infinity, window.innerHeight * 0.9);
    if (stickyOffset < MIN_VALUE) {
      setOffset(MIN_VALUE);
    }
    if (stickyOffset > MAX_VALUE) {
      setOffset(MAX_VALUE);
    }
    setCanChangeOffset(MAX_VALUE > MIN_VALUE);
  }, [isMobile, rowHeight, size$1.height, stickyOffset]);
  return {
    canChangeOffset,
    stickyOffset,
    updateOffset
  };
}

export { useStickyOffsetHandlers };
//# sourceMappingURL=hook.sticky-offset.js.map
